import {
  AppBar,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import React from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../store/actions/auth';
import Dashboard from './dashboard/Dashboard';
import { Switch, Route, NavLink, Link, Redirect } from 'react-router-dom';
import Station from './station/station';
import User from './user/User';
import StationDetails from './station/StationDetails';
import CreateCompany from './company/createcompany/CreateCompany';
import Companies from './company/companies/companies';
import CompanyDetails from './company/companydetails/CompanyDetails';
import UserDetails from './user/UserDetails';
import ConfirmCase from './confirmcase/ConfirmCase';
import CloseContact from './confirmcase/CloseContact';
import Notification from './notification/Notification';
import SuspectCase from './suspectcase/SuspectCase';

const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerContainer: {
      overflow: 'auto',
    },
    content: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(3),
    },
  })
);

const Home: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const logoutHandler = () => {
    dispatch(logout());
  };

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" noWrap>
            EPASS
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Toolbar />
        <div className={classes.drawerContainer}>
          <List>
            <ListItem button component={NavLink} to="/">
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Home" />
            </ListItem>
            <ListItem button component={NavLink} to="/notification">
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Notification" />
            </ListItem>
            <Divider />
            <ListItem button component={NavLink} to="/users">
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Users" />
            </ListItem>
            <ListItem button component={NavLink} to="/suspect-case">
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Suspect Case" />
            </ListItem>
            <ListItem button component={NavLink} to="/confirm-case">
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Confirm Case" />
            </ListItem>
          </List>
          <Divider />
          {/* <ListItem hidden={true} button component={NavLink} to="/create-company">
            <ListItemIcon>
              <InboxIcon />
            </ListItemIcon>
            <ListItemText primary="Create Company" />
          </ListItem> */}
          <ListItem button component={NavLink} to="/companies">
            <ListItemIcon>
              <InboxIcon />
            </ListItemIcon>
            <ListItemText primary="Companies" />
          </ListItem>
          <ListItem button component={NavLink} to="/stations">
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Stations" />
            </ListItem>
          <Divider />
          <List>
            <ListItem button onClick={logoutHandler}>
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItem>
          </List>
        </div>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Switch>
          <Route exact path="/stations/:id" component={StationDetails} />
          <Route exact path="/stations" component={Station} />
          <Route exact path="/notification" component={Notification} />
          <Route path="/users" component={User} />
          <Route path="/user/:id" component={UserDetails} />
          <Route path="/suspect-case" component={SuspectCase} />
          <Route path="/confirm-case/:id" component={CloseContact} />
          <Route path="/confirm-case" component={ConfirmCase} />
          <Route path="/create-company" component={CreateCompany} />
          <Route path="/company/:id" component={CompanyDetails} />
          <Route path="/companies" component={Companies} />
          <Route path="/" exact component={Dashboard} />
          <Redirect to="/" />
        </Switch>
      </main>
    </div>
  );
};

export default Home;
